<template>
  <div class="single-cell-project">
    <!-- 头部创建按钮 -->
    <div class="header" v-if="showHeader">
      <el-button
          type="success"
          size="small"
          icon="el-icon-plus"
          v-has-permission="'project_add'"
          @click="openAddProjectDialog">创建项目
      </el-button>
    </div>

    <!-- 通用表格 -->
    <w-table
        class="wMyTable"
        ref="wMyTable"
        :columns="columns"
        :table-data="tableData"
        @getTableSearchSortCon="onSearchSortChange"
        :isPagination="true"
        :table-col-check="tableColCheck"
        :page="page"
        @pageChange="onPageChange">
      <!-- 外部自定义所有列插槽 -->
      <template slot="projectId" slot-scope="{ text, record }">
        <a @click="getProjectInfo(text,record)">{{ text }}</a>
      </template>
      <template slot="rnaProjectId" slot-scope="{text,record}">
        <a class="other_link" @click="getAnalyzeInfo(text,'transWeb')">{{text }}</a>
      </template>
      <template slot="ampProjectId" slot-scope="{text,record}">
        <a class="other_link" @click="getAnalyzeInfo(text,'bzWeb')">{{text }}</a>
      </template>
      <template slot="metProjectId" slot-scope="{text,record}">
        <a class="other_link" @click="getAnalyzeInfo(text,'metaboWeb')">{{text }}</a>
      </template>
      <template slot="sampleNum" slot-scope="{text,record}">
       <span>{{ text?.length||0 }}</span>
      </template>
      <template slot="sampleInfoTrans" slot-scope="{text,record,column}">
        <span style="cursor: pointer;color: #2979cb" @click="lookSampleInfo(record,'trans')">
            <i class="viewIcon" v-html="viewDetailIcon()"></i>查看样本</span>
      </template>
      <template slot="sampleInfoBz" slot-scope="{text,record,column}">
        <span style="cursor: pointer;color: #2979cb" @click="lookSampleInfo(record,'bz')">
            <i class="viewIcon" v-html="viewDetailIcon()"></i>查看样本</span>
      </template>
      <template slot="sampleInfoMetabo" slot-scope="{text,record,column}">
        <span style="cursor: pointer;color: #2979cb" @click="lookSampleInfo(record,'metabo')">
            <i class="viewIcon" v-html="viewDetailIcon()"></i>查看样本</span>
      </template>

      <!-- 客户名称 内置通用渲染 -->
      <span slot="customerName" slot-scope="{ text, record }">
        {{ text ? Array.from(new Set(text.map(item => item.realName))).join(';') : '' }}
      </span>
      <span slot="customerCreator" slot-scope="{ text, record }">
        {{ text ? text : '系统创建' }}
      </span>
      <span slot="salesName" slot-scope="{ text, record }">
        {{ text ? Array.from(new Set(text.map(item => item.name))).join(';') : '' }}
      </span>

      <!-- 项目备注 内置 -->
      <div slot="remark" slot-scope="{ text, record }" v-if="showRemark">
        <div style="display: flex;align-items: center">
          <el-tooltip content="修改备注">
            <i
                class="el-icon-edit"
                style="color: green;cursor: pointer"
                v-has-permission="'project_edit'"
                @click="openRemarkEdit(record, 'remark')"
            ></i>
          </el-tooltip>
          <div>
            <span v-html="formatNote(text)"></span>
            <el-tooltip content="显示更多信息">
              <span
                  v-if="text && text.length > 30"
                  @click="openRemarkEdit(record, 'remark')"
                  style="font-size: 11px;cursor: pointer"
              >......</span>
            </el-tooltip>
          </div>
        </div>
      </div>

      <!-- 客户备注 内置 -->
      <div slot="customerRemark" slot-scope="{ text, record }" v-if="showCustomerRemark">
        <div style="display: flex;align-items: center">
          <el-tooltip content="修改备注">
            <i class="el-icon-edit"
               style="color: green;cursor: pointer"
               v-if="checkCustomerRemarkPerm(record)"
               @click="openRemarkEdit(record, 'customerRemark')"
            ></i>
          </el-tooltip>
          <div>
            <span v-html="formatNote(text)"></span>
            <el-tooltip content="显示更多信息">
              <span
                  v-if="text && text.length > 30"
                  @click="openRemarkEdit(record, 'customerRemark')"
                  style="font-size: 11px;cursor: pointer"
              >......</span>
            </el-tooltip>
          </div>
        </div>
      </div>

      <!-- 操作列 内置：编辑/分享/删除 全套逻辑 -->
      <template slot="operation" slot-scope="{ record }" v-if="showOperation">
        <el-button
            v-has-permission="'projects_share'"
            style="margin-left: 10px"
            size="mini"
            type="primary"
            @click="openShareDialog(record)">
          分享
        </el-button>
        <el-button
            style="margin-left: 10px"
            type="danger"
            size="mini"
            v-has-permission="'project_del'"
            @click="handleDelete(record)">
          删除
        </el-button>
      </template>
    </w-table>

    <!-- 新增/编辑项目弹窗 -->
    <add-trans-metabo-project-dialog
        v-if="showAddEditDialog"
        :show-dialog.sync="showAddEditDialog"
        :select-detail="currentRecord"
        :left-right-info="projectInfo.leftRightInfo"
        @submitData="addProject"/>

    <!-- 备注编辑弹窗 -->
    <edit-form-info-dialog
        v-if="showRemarkDialog"
        :show-dialog.sync="showRemarkDialog"
        :select-detail="currentRecord"
        @submitData="submitRemark"/>

    <!-- 加载动画 -->
    <picture-loading v-if="loading"/>

    <!-- 更换用户弹窗 -->
    <change-users
        v-if="showUserDialog"
        :show-dialog="showUserDialog"
        :select-detail="userDialogData"
        :is-has-analyze="false"
        @submit="submitChangeUser"/>
    <!-- 分享弹窗 -->
    <share-customer-manager-dialog
        v-if="showShareDialog"
        :select-detail="currentRecord"
        :platform="sharePlatform"
        :show-dialog="showShareDialog"
        @submit="closeShareDialog"/>
    <!--    样本信息-->
    <sample-info-dialog v-if="sampleInfoDialog"
                        :show-dialog.sync="sampleInfoDialog"
                        :select-detail="selectDetail"></sample-info-dialog>
  </div>
</template>

<script>
import {tableOperationMixin} from "@/mixins/tableOperation";
import AddTransMetaboProjectDialog from "@/components/project/transMetabo/AddTransMetaboProjectDialog.vue";
import EditFormInfoDialog from "@/components/EditFormInfoDialog.vue";
import PictureLoading from "@/components/customerTable/PictureLoading.vue";
import ChangeUsers from "@/components/ChangeUsers.vue";
import ShareCustomerManagerDialog from "@/components/ShareCustomerManagerDialog.vue";
import SampleGroupDetail from "@/components/project/transMetabo/SampleGroupDetail.vue";
import {viewDetailIcon} from "@/utils/iconUtils";
import SampleInfoDialog from "@/components/SampleInfoDialog.vue";

export default {
  name: "JointProjectIndex",
  components: {
    SampleInfoDialog,
    SampleGroupDetail,
    AddTransMetaboProjectDialog,
    EditFormInfoDialog,
    PictureLoading,
    ChangeUsers,
    ShareCustomerManagerDialog
  },
  mixins: [tableOperationMixin],
  props: {
    // ========== 1. 接口集合（必传，不同业务传不同接口） ==========
    api: {
      type: Object,
      required: true,
      default: () => ({
        getList: () => Promise.resolve({code: 200, data: {}}),
        del: () => Promise.resolve({code: 200}),
        editRemark: () => Promise.resolve({code: 200}),
        editCustomerRemark: () => Promise.resolve({code: 200}),
        changeUser: () => Promise.resolve({code: 200})
      })
    },
    // ========== 2. 表格列配置（必传） ==========
    tableColumns: {
      type: Array,
      required: true
    },
    tableColKey: {
      type: String,
      default: "default_col"
    },
    // ========== 5. 分享平台标识 ==========
    sharePlatform: {
      type: String,
      default: "TRANS_METABO"
    },
    // ========== 6. 模块显隐控制 ==========
    show: {
      type: Object,
      default: () => ({
        header: true,
        remark: true,
        customerRemark: true,
        operation: true
      })
    },
    projectInfo: {
      type: Object,
      default: () => ({
        leftRightInfo: {}
      })
    }
  },
  data() {
    return {
      loading: false,
      tableData: [],
      // 分页
      page: {
        total: 0,
        pageSize: 10,
        pageNum: 1,
        currentNum: 1,
        pageSizes: [10, 20, 50, 100]
      },
      tableColCheck: {isShow: true, name: ""},
      searchConditionTag: [],
      sortConditionTag: [],

      // 弹窗状态
      showAddEditDialog: false,
      showRemarkDialog: false,
      showShareDialog: false,
      showUserDialog: false,

      // 当前操作数据
      currentRecord: null,
      remarkType: "",
      userDialogData: {},
      sampleInfoDialog: false,
      selectDetail: {}
    };
  },
  computed: {
    columns() {
      return this.tableColumns;
    },
    showHeader() {
      return this.show.header;
    },
    showRemark() {
      return this.show.remark;
    },
    showCustomerRemark() {
      return this.show.customerRemark;
    },
    showOperation() {
      return this.show.operation;
    }
  },
  created() {
    this.tableColCheck.name = this.tableColKey;
  },
  mounted() {
    this.getTableData(true);
  },
  methods: {
    viewDetailIcon() {
      return viewDetailIcon
    },
    // --------------- 基础：获取表格数据 ---------------
    async getTableData(isInit = false) {
      this.loading = true;
      try {
        const params = {
          "page.current": isInit ? 1 : this.page.currentNum,
          "page.size": isInit ? 10 : this.page.pageSize
        };
        const searchParams = {};
        this.searchConditionTag.forEach(item => {
          searchParams[item.key] = item.value;
        });
        if (this.sortConditionTag.length) {
          const sort = this.sortConditionTag[0];
          params.order = `${sort.colName}.${sort.order}`;
        }
        const res = await this.api.getList(params, searchParams);
        if (res.code === 200) {
          this.tableData = res.data.records || [];
          this.page.total = Number(res.data.total || 0);
          this.page.pageSize = Number(res.data.size || 10);
          this.page.currentNum = Number(res.data.current || 1);
        }
      } catch (err) {
        this.$message.error("数据加载失败");
      } finally {
        this.loading = false;
      }
    },

    // --------------- 搜索、排序、分页 ---------------
    onSearchSortChange(search, sort) {
      this.searchConditionTag = search;
      this.sortConditionTag = sort;
      this.getTableData(true);
    },
    onPageChange(page) {
      this.page.currentNum = page.currentNum;
      this.page.pageSize = page.pageSize;
      this.getTableData();
    },
    addProject(sendData, childCallback) {
      // 把收到的数据+子组件的回调 原样透传给祖
      this.$emit("addProject", sendData, (callBack)=>{
        if(callBack){
         this.getTableData()
        }
        childCallback(callBack);
      })
    },

    // --------------- 新增 / 编辑项目 ---------------
    openAddProjectDialog() {
      this.currentRecord = null;
      this.showAddEditDialog = true;
    },

    // --------------- 备注编辑 ---------------
    openRemarkEdit(record, type) {
      this.remarkType = type;
      this.currentRecord = {
        projectId: record.id,
        title: "编辑备注",
        form: {}
      };
      if (type === "remark") {
        this.currentRecord.form.remark = {
          value: record.remark,
          type: "textarea",
          label: "项目备注"
        };
      } else {
        this.currentRecord.form.customerRemark = {
          value: record.customerRemark,
          type: "textarea",
          label: "备注"
        };
      }
      this.showRemarkDialog = true;
    },
    async submitRemark(data) {
      let res;
      const val = Object.values(data.form)[0]?.value || " ";
      if (this.remarkType === "remark") {
        res = await this.api.editRemark(data.projectId, val);
      } else {
        res = await this.api.editCustomerRemark(data.projectId, val);
      }
      if (res?.code === 200) {
        this.showRemarkDialog = false;
        this.$messageUi.success("修改成功");
        this.updateTableByNextTick();
      } else {
        this.$message.error("修改失败");
      }
    },

    // --------------- 删除项目 ---------------
    async handleDelete(record) {
      await this.$confirmUi("此操作将会永久删除该项目, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      const res = await this.api.del(record.id);
      if (res.code === 200) {
        this.$message.success("删除成功");
        this.fixPageAfterDel();
        this.updateTableByNextTick();
      }
    },
    // 删除后修复分页
    fixPageAfterDel() {
      const totalPage = Math.ceil((this.page.total - 1) / this.page.pageSize);
      this.page.currentNum = Math.max(1, Math.min(this.page.currentNum, totalPage));
    },

    // --------------- 分享 ---------------
    openShareDialog(record) {
      this.currentRecord = {
        projectId: record.id,
        customerList: record.customerInfos
      };
      this.showShareDialog = true;
    },
    closeShareDialog() {
      this.showShareDialog = false;
    },

    // --------------- 更换用户（内置） ---------------
    openChangeUser(row) {
      this.userDialogData = {
        selectedSalers: row.sales?.map(item => item.uuid[0]) || [],
        selectedCustomers: row.customerInfos?.map(item => item.emailAccount) || [],
        selectedCustomersInfo: row.customerInfos,
        projectId: row.id
      };
      this.showUserDialog = true;
    },
    async submitChangeUser(data, type) {
      this.showUserDialog = false;
      if (type === "cancel") return;
      const send = {
        projectId: data.projectId,
        salesUuid: data.selectedSalers,
        customerIds: data.customerIds
      };
      const res = await this.api.changeUser(send);
      if (res.code === 200) {
        this.$message.success("修改成功");
        this.updateTableByNextTick();
      }
    },
    updateTableByNextTick() {
      this.$nextTick(() => {
        this.getTableData();
      });
    },
    lookSampleInfo(record,platforms) {
      let platform
      let projectId
      switch (platforms) {
        case 'bz':
          platform = 'AMPLICON'
          projectId = record.ampProjectId
          break;
        case 'trans':
          platform = 'TRANS'
          projectId = record.rnaProjectId
          break;
        case 'metabo':
          platform = 'METABO'
          projectId = record.metProjectId
          break;
      }
      this.selectDetail = {
        projectId: projectId,
        platform: platform
      }
      this.sampleInfoDialog = true
    },
    // --------------- 工具方法 ---------------
    // 备注文本截断
    formatNote(text) {
      if (!text) return "";
      return text.length > 30 ? text.substring(0, 30) : text;
    },
    // 客户备注编辑权限判断
    checkCustomerRemarkPerm(record) {
      const userId = this.$store.getters["right/getUser"]?.customer?.id;
      const role = this.$store.getters["right/getRole"];
      return (record?.customerInfos || []).map(item => item.id).includes(userId) || ["ADMIN", "MANAGER"].includes(role);
    },
    getProjectInfo(projectId, row) {
      let prefix = this.sharePlatform === "TRANS_METABO" ? "transMetaboWeb" : "ampMetaboWeb"
      window.open(`/${prefix}/desc?projectId=` + projectId)
    },
    //跳转到具体的分析
    getAnalyzeInfo(projectId, webPre) {
      window.open(`/${webPre}/desc?projectId=${projectId}`)
    },
  }
};
</script>

<style scoped>
.header {
  margin-bottom: 20px;
}

.single-cell-project {
  padding: 0;
}

.other_link {
  color: #3788da;
}
</style>
